import React, { useMemo } from "react";
import styles from "./index.module.less";
import { changeEgovUrl } from "@/utils/tools";

function SvgIcon(props: any) {
  const { url, style, useImage = false } = props;
  const realUrl = useMemo(() => {
    return changeEgovUrl(url);
  }, [url]);

  if (useImage) {
    return (
      <img
        src={realUrl}
        className={styles["svg-wrap"]}
        style={{
          ...style
        }}
      />
    );
  }

  return (
    <div
      className={styles["svg-wrap"]}
      style={{
        ...style,
        WebkitMaskImage: `url(${realUrl})`,
        maskImage: `url(${realUrl})`
      }}
    />
  );
}

export default SvgIcon;
